export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL";

export const USER_SIGNUP_REQUEST = "USER_SIGNUP_REQUEST";
export const USER_SIGNUP_SUCCESS = "USER_SIGNUP_SUCCESS";
export const USER_SIGNUP_FAIL = "USER_SIGNUP_FAIL";

export const USER_OTP_VERIFY_REQUEST = "USER_OTP_VERIFY_REQUEST";
export const USER_OTP_VERIFY_SUCCESS = "USER_OTP_VERIFY_SUCCESS";
export const USER_OTP_VERIFY_FAIL = "USER_OTP_VERIFY_FAIL";

export const USER_OTP_RESEND_REQUEST = "USER_OTP_RESEND_REQUEST";
export const USER_OTP_RESEND_SUCCESS = "USER_OTP_RESEND_SUCCESS";
export const USER_OTP_RESEND_FAIL = "USER_OTP_RESEND_FAIL";

// Send OTP (from login page)
export const USER_SENDOTP_REQUEST = "USER_SENDOTP_REQUEST";
export const USER_SENDOTP_SUCCESS = "USER_SENDOTP_SUCCESS";
export const USER_SENDOTP_FAIL = "USER_SENDOTP_FAIL";